export default __webpack_public_path__ + "static/media/laptop.b8a34893.svg";